const inputConfig = [
  {
    id: "color-stripes",
    action: "bid#colorstripes",
    data: [
      { value: "stripes-cut", label: "Klipp og striper" },
      { value: "stripes", label: "Kun striper" },
      { value: "color-cut", label: "Klipp og farge" },
      { value: "color", label: "Kun farge" },
      { value: "color-root", label: "Kun farge, ettervekst" },
    ],
  },
  {
    id: "cut-length",
    action: "bid#cutlength",
    data: [
      { value: "short", label: "Til ørene eller kortere" },
      { value: "shoulders", label: "Til skuldrene" },
      { value: "long", label: "Midt på ryggen eller lengre" },
    ],
  },
  {
    id: "time",
    action: "bid#time",
    prepend: true, // need to prepend because of specific-time extra input
    data: [
      { value: "week", label: "I løpet av de neste 5 dagene" },
      { value: "asap", label: "ASAP, det haster" },
    ],
  },
  {
    id: "place",
    action: "bid#place",
    data: [
      { value: "bergen-sentrum", label: "Bergen sentrum" },
      { value: "bergen-sor", label: "Bergen sør" },
      { value: "bergen-aasane", label: "Åsane" },
      { value: "bergen-vest", label: "Bergen Vest" },
    ],
  },
];

const priceConfig = {
  "cut": [350,500,700,1000],
  "color-stripes": [1000,1500,2500,3500],
  "stripes-cut": [1000,1500,2500,3500],
  "stripes": [500,1000,2000,3000],
  "color-cut": [1000,1500,2500,3500],
  "color": [500,1000,2000,3000],
  "color-root": [300,500,1000,1500],
};

export {
  inputConfig,
  priceConfig,
}

